import { createReducer } from '../../utilities';
import { getChampionships } from "@monpetitgazon/mpg-team-data";

import { UPDATE_TEXT_AREA, RESET_GROUP, scope } from '../../../actions/app/tools/tds/listWidget';

let championships = {};
getChampionships().forEach(value => championships[value.id] = { teams: {} });
const initialState = { championships };

function success(state, action) {
    const {club, championship, value} = action.payload;
    return ({
        ...state,
        championships: {
            ...state.championships,
            [championship]: {
                teams: {
                    ...state.championships[championship].teams,
                    [club]: value,
                }
            }
        },
    });
}

function reset() {
    return initialState;
}

export default createReducer(initialState, {
    [UPDATE_TEXT_AREA]: success,
    [RESET_GROUP]: reset,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/tools/groupStorage.js